import { Card } from "../card"
import Wrapper from "./style"

export const Navigations = ({assets,assetsLoadingMessage}) => {
    return (
        <Wrapper>
            {
                assets.length ? 
                <>
                    <h1>All assets</h1>
                    <p>Select an asset to learn more, or use the 'Acces Data' link to go straight to the data.</p>
                    <div className="cards">
                        {
                            assets.map(card => <Card key={card.assetId} {...card} />)
                        }
                    </div>
                </> : <p>{assetsLoadingMessage}</p>
            }
        </Wrapper>
    )
}
